var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.itemData.data.length
  var l0 =
    g0 > 0
      ? _vm.__map(_vm.itemData.data, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var m0 =
            item.live_status == 101 ||
            item.live_status == 102 ||
            item.live_status == 104
              ? _vm.convertStatus(item.live_status)
              : null
          return {
            $orig: $orig,
            m0: m0,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }